import template from "./entity-customer-transactions.html";
import "./entity-customer-transactions.less";
import cloneDeep from "clone-deep";

import { BUSINESS_CUSTOMER_TRANSACTIONS } from "../../../../../../../routes";

import {
	ENTITY_TRANSLATION_KEYS, 
	I18NextContext 
} from "../../../../../../../services/i18nService";

export function controller($logger, $scope, $uibModal, toastr, appState) {
	const ctrl = this;

	ctrl.i18n = I18NextContext.Instance;
	ctrl.ENTITY_TRANSLATION_KEYS = ENTITY_TRANSLATION_KEYS;
	
	ctrl.$onInit = () => {
		$scope.$watch(() => ctrl.transactions, (next) => {
			if(next === undefined) {
				return;
			}
			ctrl.loadTransactions();
		});
	};

	ctrl.loadTransactions = async() => {
		ctrl.colspan = ctrl.isInvoices === true  ? "5" : "6";
		ctrl.hydratedTransactions = cloneDeep(ctrl.transactions);

		if(ctrl.isInvoices) {
			ctrl.hydratedTransactions = ctrl.hydratedTransactions
				.map(t => {
					return {
						...t,
						activeInvoice: t.Invoices.find(i => !i.State?.IsVoid)
					};
				});
		}
	};

	ctrl.newTransaction = async() => {
		const update = await $uibModal.open({
			component: "business-customer-new-transaction-modal",
			size: "smmd",
			backdrop: "static",
			resolve: {
				charges: () => ([...ctrl.availableCharges]),
				allProducts: () => ([...ctrl.allProducts]),
				save: () => (payload) => ctrl.saveNewTransaction(payload)
			}
		}).result;

		const matchindex = ctrl.hydratedTransactions.findIndex(c => c.Id === update.Id);
		if(matchindex !== -1) {
			ctrl.hydratedTransactions[matchindex] = update;
		}
		else {
			ctrl.hydratedTransactions.push(update);
		}	
		$logger.snapshot("updated transactions", ctrl.hydratedTransactions);

		return update;
	};

	// paramsType = {
	// 	product: {
	// 		code, 
	// 		quantity
	// 	}, 
	// 	item: {
	// 		name,
	// 		price
	// 	},
	// 	fees 
	// }
	ctrl.saveNewTransaction = async(params) => {
		const Transaction = params.item === undefined ?
			{
				Product: {
					Code: params.product.code
				},
				Quantity: params.product.quantity
			} :
			{
				Item: params.item.name,
				Price: params.item.price
			};

		Transaction.Fees = params.fees;
		const txnPayload = Transaction;

		try {
			return ctrl.post(BUSINESS_CUSTOMER_TRANSACTIONS(appState.forms.selected.Id, ctrl.businessId, ctrl.customerId), txnPayload);
		}
		catch(err) {
			$logger.exception(err, "error saving new customer transaction");
			toastr.error("There was an error saving the new transaction");
		}
	};
}

export default angular.module("vesl.components.entity-customer-transactions", [])
	.component("entityCustomerTransactions", {
		controller,
		template,
		bindings: {
			transactions: "<",
			availableCharges: "<",
			allProducts: "<",
			isInvoices: "<",
			businessId: "<",
			customerId: "<",
			put: "=",
			post: "="
		}
	})
	.name;
